import { Component, Input, OnChanges, OnInit } from "@angular/core";

@Component({
    selector: "app-alert",
    templateUrl: "./alert.component.html",
    styleUrls: ['./alert.component.scss'],
    standalone: false
})
export class AlertComponent implements OnInit, OnChanges {
  @Input() type: string;
  @Input() title: string;
  @Input() message: string;
  informationalAlert = false;
  warningAlert = false;
  validInput = false;

  constructor() {}

  ngOnInit() {
    this.setAlert();
  }
  
  ngOnChanges() {
    this.setAlert();
  }

  setAlert() {
    if (this.type === 'info') {
      this.resetType();
      this.informationalAlert = true;
      this.validInput = true;
    } else if (this.type === 'warning') {
      this.resetType();
      this.warningAlert = true;
      this.validInput = true;
    }
  }
  
  resetType() {
    this.warningAlert = false;
    this.informationalAlert = false;
  }
}
